const $ = jQuery.noConflict();

class Slider {
	constructor(selector, args = {}) {
		this.selector = selector;
		this.args = args;
	}

	getDefaultSlickSettings() {
		return {
			dots: false,
			arrows: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			pauseOnHover: false,
			speed: 600,
		};
	}

	/**
	 * Override our default slick settings with args provided to the class.
	 */
	getSlickSettings() {
		return Object.assign({}, this.getDefaultSlickSettings(), this.args);
	}

	init() {
		const settings = this.getSlickSettings();

		$(this.selector).slick(settings);

		if (
			this.selector ===
				'.block-slider-gallery--hard .gallery-slider__slider-fluid' ||
			this.selector ===
				'block-slider-gallery--flexible .gallery-slider__slider-fluid'
		) {
			const slideLink = document.querySelectorAll('[data-slide-id]');

			slideLink.forEach((e) => {
				e.addEventListener('click', () => {
					const slideId = e.dataset.slideId;
					$(this.selector).slick('slickGoTo', slideId);
				});
			});
		}
	}
}

const SimpleSlider = new Slider('.gallery-slider__slider');
const TestimonialSlider = new Slider('.testimonial-slider', {
	adaptiveHeight: true,
});
const FluidSlider = new Slider(
	'.block-slider-gallery--hard .gallery-slider__slider-fluid',
	{
		centerMode: true,
		variableWidth: true,
	}
);
const FlexibleSlider = new Slider(
	'.block-slider-gallery--flexible .gallery-slider__slider-fluid',
	{
		centerMode: true,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					centerMode: false,
					variableWidth: false,
				},
			},
		],
	}
);
export { SimpleSlider, TestimonialSlider, FluidSlider, FlexibleSlider };
